import styled from 'styled-components';

const Clickable = styled.button`
  /* Reset default button styles */
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  line-height: inherit;
  text-align: inherit;
  text-decoration: none;
  cursor: pointer;

  /* Ensure proper box model */
  box-sizing: border-box;

  /* Remove default focus outline - we'll add custom accessible focus styles */
  outline: none;

  /* Accessible focus styles using :focus-visible for keyboard navigation */
  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  // Some haikus, for your reading pleasure:
  // -------------------------------------
  // Laggard Firefox,
  // inner focus is for monks.
  // Chrome whispers "Choose me"
  // -------------------------------------
  // Focus. Firefox
  // stands for F in WTF.
  // Focus on yourself.
  // -------------------------------------
  // focus-inner, huh?
  // greatest irony, you need,
  // browser therapy.
  &::-moz-focus-inner {
    border: 0;
    margin: 0;
    padding: 0;
  }

  /* Disabled state */
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  /* Prevent text selection on double click */
  user-select: none;
  -webkit-tap-highlight-color: transparent;
`;

export { Clickable };
